export const mockDiscussions = [
  // ============ POLL: DRAMA RECOMMENDATION ============
  {
    id: 'poll-001',
    slug: 'vote-best-drama-genre-2025-community-poll',
    title: '🗳️ Vote: What Drama Genre Should We Feature Next Month?',
    content: "We're planning our next community spotlight and want YOUR input! Vote for the drama genre you'd like us to focus on. The winning genre will get a dedicated week of recommendations, reviews, and creator interviews. Every vote counts!",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-admin',
      username: 'Community Team',
      avatar: 'https://public.readdy.ai/ai/img_res/efde69f7655bfa18e370d49d7260c33c.jpg',
      reputation: 999
    },
    upvotes: 234,
    downvotes: 5,
    commentCount: 89,
    views: 4567,
    tags: ['poll', 'community-vote', 'drama-genre', 'featured'],
    isPinned: true,
    isLiked: false,
    likes: 234,
    metadata: {
      discussionType: 'poll',
      mood: 'excited',
      type: 'general_discussion',
      poll: {
        options: [
          { id: 'option-0', text: 'Romance & Love Stories', votes: 156 },
          { id: 'option-1', text: 'Thriller & Mystery', votes: 98 },
          { id: 'option-2', text: 'Historical Period Dramas', votes: 87 },
          { id: 'option-3', text: 'Family & Slice of Life', votes: 64 },
          { id: 'option-4', text: 'Action & Adventure', votes: 52 },
          { id: 'option-5', text: 'AI-Generated Dramas', votes: 123 }
        ],
        allowMultiple: false,
        showResults: true,
        endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        totalVotes: 580
      }
    },
    createdAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 15 * 60 * 1000).toISOString()
  },
  // ============ GENERAL DISCUSSION (10 posts) ============
  {
    id: 'disc-001',
    slug: 'what-makes-great-arab-drama-storytelling-elements',
    title: "What makes a great Arab drama? Let's discuss the key elements",
    content: "I've been watching Arab dramas for years and I'm curious about what everyone thinks makes a drama truly exceptional. Is it the storytelling, the acting, the production quality, or something else entirely?",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-001',
      username: 'Amira Hassan',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20woman%20with%20warm%20smile%20wearing%20elegant%20business%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=disc1&orientation=squarish',
      reputation: 342
    },
    upvotes: 67,
    downvotes: 3,
    commentCount: 24,
    views: 1250,
    tags: ['discussion', 'storytelling', 'culture'],
    isPinned: false,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'disc-002',
    slug: 'best-arab-drama-2024-top-picks-recommendations',
    title: 'Best drama of 2024 so far? Share your top picks!',
    content: "We're halfway through 2024 and there have been some incredible releases. What's been your favorite Arab drama this year? I'd love to hear everyone's recommendations.",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-002',
      username: 'Omar Al-Rashid',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20friendly%20expression%20wearing%20casual%20shirt%20natural%20lighting%20clean%20background&width=80&height=80&seq=disc2&orientation=squarish',
      reputation: 289
    },
    upvotes: 45,
    downvotes: 2,
    commentCount: 18,
    views: 980,
    tags: ['2024', 'recommendations', 'favorites'],
    isPinned: true,
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-003',
    slug: 'short-drama-format-future-entertainment',
    title: 'Is the short drama format the future of entertainment?',
    content: "With attention spans getting shorter and mobile viewing on the rise, short dramas seem perfectly positioned. Do you think this format will eventually overtake traditional long-form series?",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-013',
      username: 'Khalid Mansour',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20man%20with%20intellectual%20expression%20wearing%20glasses%20and%20smart%20casual%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=gen3&orientation=squarish',
      reputation: 456
    },
    upvotes: 89,
    downvotes: 12,
    commentCount: 45,
    views: 2340,
    tags: ['short-drama', 'future', 'format', 'debate'],
    isPinned: false,
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-011',
    slug: 'ai-fatigue-real-authenticity-matters-2025',
    title: 'Is AI fatigue real? Why authenticity matters more than ever in 2025',
    content: "I've noticed viewers are starting to suffer from 'AI fatigue' - too much synthetic content everywhere. Successful creators are now intentionally leaving in human imperfections like stutters or raw behind-the-scenes clips to maintain trust. What do you think about this shift back to authenticity?",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-059',
      username: 'Authenticity Advocate',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20thoughtful%20expression%20wearing%20casual%20modern%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=gen11&orientation=squarish',
      reputation: 423
    },
    upvotes: 234,
    downvotes: 18,
    commentCount: 89,
    views: 4567,
    tags: ['ai-fatigue', 'authenticity', '2025-trends', 'human-touch'],
    isPinned: true,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-012',
    slug: 'micro-dramas-90-second-episodes-changing-viewing-habits',
    title: 'Micro-dramas with 90-second episodes are changing how we watch content',
    content: "China's micro-drama market has exploded with 90-second episodes that can be produced in minutes. The industry is projected to reach nearly $12.5 billion by end of 2025! Are we ready for this format in Arab content? I personally love being able to watch a complete story arc during my coffee break.",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-060',
      username: 'Micro Content Fan',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20man%20with%20excited%20expression%20wearing%20trendy%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=gen12&orientation=squarish',
      reputation: 312
    },
    upvotes: 156,
    downvotes: 23,
    commentCount: 67,
    views: 3456,
    tags: ['micro-dramas', '90-seconds', 'china', 'viewing-habits'],
    isPinned: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-004',
    slug: 'arabic-dialect-preferences-drama-watching',
    title: 'Which Arabic dialect do you prefer in dramas?',
    content: "I've noticed dramas use different dialects - Egyptian, Gulf, Levantine, etc. Does the dialect affect your enjoyment? I personally love Gulf dialect dramas but curious what others think.",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-014',
      username: 'Nadia Qasim',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20woman%20with%20curious%20expression%20wearing%20colorful%20hijab%20studio%20lighting%20clean%20background&width=80&height=80&seq=gen4&orientation=squarish',
      reputation: 234
    },
    upvotes: 56,
    downvotes: 4,
    commentCount: 67,
    views: 1890,
    tags: ['dialect', 'arabic', 'language', 'preferences'],
    isPinned: false,
    createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-005',
    slug: 'binge-watching-vs-weekly-release-preference',
    title: 'Binge-watching vs weekly releases - what do you prefer?',
    content: "Some platforms release all episodes at once while others do weekly drops. I find weekly releases build more anticipation and community discussion. What's your take?",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-015',
      username: 'Tariq Abdullah',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20man%20with%20relaxed%20expression%20wearing%20casual%20hoodie%20natural%20lighting%20clean%20background&width=80&height=80&seq=gen5&orientation=squarish',
      reputation: 178
    },
    upvotes: 34,
    downvotes: 2,
    commentCount: 29,
    views: 756,
    tags: ['binge-watching', 'weekly', 'viewing-habits'],
    isPinned: false,
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 11 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-006',
    slug: 'drama-soundtracks-underrated-aspect',
    title: 'Drama soundtracks are so underrated! Share your favorites',
    content: "The music in Arab dramas often goes unnoticed but it adds so much to the emotional impact. The Desert Winds soundtrack literally gives me chills every time.",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-016',
      username: 'Yasmin Fares',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20passionate%20expression%20wearing%20headphones%20around%20neck%20studio%20lighting%20clean%20background&width=80&height=80&seq=gen6&orientation=squarish',
      reputation: 312
    },
    upvotes: 78,
    downvotes: 1,
    commentCount: 34,
    views: 1234,
    tags: ['soundtrack', 'music', 'ost', 'favorites'],
    isPinned: false,
    createdAt: new Date(Date.now() - 15 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 14 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-007',
    slug: 'introducing-myself-new-member-community',
    title: 'New member here! Excited to join this community',
    content: "Hi everyone! I just discovered Arab short dramas last month and I'm completely hooked. Started with Noor and now I can't stop watching. Any recommendations for a newbie?",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-017',
      username: 'Maria Santos',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Latina%20woman%20with%20friendly%20smile%20wearing%20casual%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=gen7&orientation=squarish',
      reputation: 45
    },
    upvotes: 123,
    downvotes: 0,
    commentCount: 56,
    views: 2100,
    tags: ['introduction', 'newbie', 'welcome'],
    isPinned: false,
    createdAt: new Date(Date.now() - 18 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 17 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-013',
    slug: 'human-actors-vs-ai-generated-characters-poll',
    title: 'Poll: Do you prefer human actors or AI-generated characters?',
    content: "A 2025 fan study revealed that 64% of vertical drama viewers still prefer human actors over synthetic ones, citing a need for genuine emotional connection. Where do you stand? I think there's room for both, but nothing beats real human performances for emotional scenes.",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-061',
      username: 'Drama Pollster',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20analytical%20expression%20wearing%20smart%20casual%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=gen13&orientation=squarish',
      reputation: 289
    },
    upvotes: 189,
    downvotes: 34,
    commentCount: 145,
    views: 5678,
    tags: ['poll', 'human-actors', 'ai-characters', 'debate'],
    isPinned: false,
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'gen-010',
    slug: 'unpopular-opinions-arab-dramas-thread',
    title: 'Unpopular opinions about Arab dramas - share yours!',
    content: "I'll start: I think some highly-rated dramas are overrated and some underrated ones deserve more attention. What are your unpopular opinions? Keep it respectful!",
    category: 'general',
    categoryName: 'General Discussion',
    author: {
      id: 'user-020',
      username: 'Faisal Noor',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20man%20with%20mischievous%20smile%20wearing%20trendy%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=gen10&orientation=squarish',
      reputation: 345
    },
    upvotes: 156,
    downvotes: 23,
    commentCount: 89,
    views: 3456,
    tags: ['unpopular-opinions', 'debate', 'discussion', 'hot-takes'],
    isPinned: false,
    createdAt: new Date(Date.now() - 28 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 27 * 60 * 60 * 1000).toISOString()
  },

  // ============ DRAMA REVIEWS (10 posts) ============
  {
    id: 'disc-003',
    slug: 'noor-episode-12-review-masterpiece-emotional-storytelling',
    title: 'Noor Episode 12 Review - A Masterpiece of Emotional Storytelling',
    content: 'This episode absolutely blew me away. The character development and emotional depth reached new heights. The scene between Noor and her mother was particularly moving.',
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-003',
      username: 'Sara Al-Mansouri',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20thoughtful%20expression%20wearing%20elegant%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=disc3&orientation=squarish',
      reputation: 312
    },
    upvotes: 42,
    downvotes: 2,
    commentCount: 15,
    views: 876,
    tags: ['noor', 'episode-review', 'emotional'],
    rating: 5,
    drama: 'Noor',
    isPinned: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rev-011',
    slug: 'warlord-ai-series-review-shekhar-kapur-vision',
    title: 'Warlord Review: Shekhar Kapur\'s AI-Generated Sci-Fi Series Impresses',
    content: "Just watched the first episodes of Warlord, the sci-fi series created entirely through AI by acclaimed filmmaker Shekhar Kapur. The interdimensional warrior storyline is captivating, and the visuals are stunning. While you can tell it's AI-generated, the artistic direction elevates it beyond typical AI content. Kapur's vision really shines through.",
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-062',
      username: 'Sci-Fi Enthusiast',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20man%20with%20excited%20expression%20wearing%20sci-fi%20themed%20shirt%20studio%20lighting%20clean%20background&width=80&height=80&seq=rev11&orientation=squarish',
      reputation: 456
    },
    upvotes: 178,
    downvotes: 23,
    commentCount: 67,
    views: 4567,
    tags: ['warlord', 'ai-generated', 'shekhar-kapur', 'sci-fi', 'review'],
    rating: 4,
    drama: 'Warlord',
    isPinned: true,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString()
  },
  {
    id: 'rev-012',
    slug: 'non-player-combat-ai-reality-show-review',
    title: 'Non-Player Combat: World\'s First AI Reality Show - Is It Worth Watching?',
    content: "Non-Player Combat features six AI contestants with autonomous personalities making real-time decisions on a survival island. It's bizarre, fascinating, and sometimes uncanny. The AI contestants develop unexpected alliances and conflicts. Not sure if I love it or find it unsettling, but I can't stop watching!",
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-063',
      username: 'Reality TV Junkie',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20intrigued%20expression%20wearing%20casual%20trendy%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rev12&orientation=squarish',
      reputation: 345
    },
    upvotes: 234,
    downvotes: 45,
    commentCount: 123,
    views: 6789,
    tags: ['non-player-combat', 'ai-reality-show', 'autonomous-ai', 'review'],
    rating: 3,
    drama: 'Non-Player Combat',
    isPinned: false,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rev-013',
    slug: 'beyond-the-loop-memory-maker-episode-review',
    title: 'Beyond the Loop: Memory Maker Episode - Black Mirror Vibes Done Right',
    content: "Wonder Studios' AI-driven anthology series Beyond the Loop just dropped its first episode 'Memory Maker'. Set in a post-apocalyptic world where human memories are implanted into androids, it's giving major Black Mirror energy. The philosophical questions it raises about consciousness and identity are thought-provoking. Highly recommend!",
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-064',
      username: 'Anthology Lover',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20philosophical%20expression%20wearing%20dark%20turtleneck%20studio%20lighting%20clean%20background&width=80&height=80&seq=rev13&orientation=squarish',
      reputation: 512
    },
    upvotes: 189,
    downvotes: 12,
    commentCount: 78,
    views: 3456,
    tags: ['beyond-the-loop', 'memory-maker', 'anthology', 'ai-drama', 'black-mirror'],
    rating: 5,
    drama: 'Beyond the Loop',
    isPinned: false,
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'disc-004',
    slug: 'desert-winds-season-finale-epic-conclusion-review',
    title: 'Desert Winds Season Finale - Epic Conclusion to an Amazing Journey',
    content: 'What a way to end the season! The finale tied up all loose ends perfectly while setting up exciting possibilities for the next season.',
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-004',
      username: 'Mohammed Hassan',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20enthusiastic%20expression%20wearing%20casual%20modern%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=disc4&orientation=squarish',
      reputation: 278
    },
    upvotes: 67,
    downvotes: 3,
    commentCount: 22,
    views: 1340,
    tags: ['desert-winds', 'season-finale', 'epic'],
    rating: 5,
    drama: 'Desert Winds',
    isPinned: false,
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rev-004',
    slug: 'the-last-garden-complete-series-review',
    title: 'The Last Garden - Complete Series Review (No Spoilers)',
    content: "Just finished The Last Garden and I'm emotionally wrecked in the best way possible. This drama perfectly balances romance, family drama, and social commentary. A must-watch!",
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-021',
      username: 'Hana Mahmoud',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20emotional%20expression%20wearing%20elegant%20dress%20studio%20lighting%20clean%20background&width=80&height=80&seq=rev4&orientation=squarish',
      reputation: 423
    },
    upvotes: 89,
    downvotes: 4,
    commentCount: 34,
    views: 2345,
    tags: ['the-last-garden', 'complete-review', 'no-spoilers'],
    rating: 5,
    drama: 'The Last Garden',
    isPinned: false,
    createdAt: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rev-005',
    slug: 'midnight-secrets-disappointing-finale-review',
    title: 'Midnight Secrets - A Disappointing Finale (Spoilers)',
    content: "I hate to say it but the finale of Midnight Secrets really let me down. After such a strong buildup, the ending felt rushed and left too many questions unanswered.",
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-022',
      username: 'Samir Osman',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20disappointed%20expression%20wearing%20casual%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=rev5&orientation=squarish',
      reputation: 267
    },
    upvotes: 45,
    downvotes: 12,
    commentCount: 67,
    views: 1890,
    tags: ['midnight-secrets', 'finale', 'spoilers', 'criticism'],
    rating: 2,
    drama: 'Midnight Secrets',
    isPinned: false,
    createdAt: new Date(Date.now() - 14 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 13 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rev-006',
    slug: 'golden-sands-episode-5-plot-twist-review',
    title: 'Golden Sands Episode 5 - That Plot Twist Changed Everything!',
    content: "I did NOT see that coming! Episode 5 completely flipped the narrative and now I'm questioning everything I thought I knew about the characters. Brilliant writing!",
    category: 'reviews',
    categoryName: 'Drama Reviews',
    author: {
      id: 'user-023',
      username: 'Dina Rashid',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20shocked%20expression%20wearing%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rev6&orientation=squarish',
      reputation: 345
    },
    upvotes: 78,
    downvotes: 2,
    commentCount: 45,
    views: 1567,
    tags: ['golden-sands', 'plot-twist', 'episode-5'],
    rating: 4,
    drama: 'Golden Sands',
    isPinned: false,
    createdAt: new Date(Date.now() - 16 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 15 * 60 * 60 * 1000).toISOString()
  },

  // ============ CREATOR SPOTLIGHT (10 posts) ============
  {
    id: 'disc-005',
    slug: 'layla-al-rashid-acting-evolution-debut-stardom',
    title: "Layla Al-Rashid's Acting Evolution: From Debut to Stardom",
    content: "I've been following Layla's career since her first role, and her growth as an actress has been incredible to watch. Her range and emotional depth continue to impress.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-005',
      username: 'Fatima Al-Zahra',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20woman%20with%20admiring%20expression%20wearing%20elegant%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=disc5&orientation=squarish',
      reputation: 267
    },
    upvotes: 45,
    downvotes: 3,
    commentCount: 12,
    views: 756,
    tags: ['layla-al-rashid', 'acting', 'career'],
    isPinned: false,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-010',
    slug: 'one-person-studio-revolution-sensetime-seko',
    title: 'The One-Person Studio Revolution: How SenseTime\'s Seko 2.0 is Changing Everything',
    content: "New tools like SenseTime's Seko 2.0 are enabling 'one-person studios' to write, produce, and release hit series in minutes. I interviewed a creator who went from zero to 1 million views using just this tool. The democratization of content creation is real!",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-066',
      username: 'Creator Economy Watch',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20man%20with%20innovative%20expression%20wearing%20tech%20startup%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre10&orientation=squarish',
      reputation: 534
    },
    upvotes: 267,
    downvotes: 12,
    commentCount: 89,
    views: 5678,
    tags: ['one-person-studio', 'sensetime', 'seko', 'ai-tools', 'creator-economy'],
    isPinned: true,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-011',
    slug: 'faceless-youtube-channels-ai-avatars-success-stories',
    title: 'Faceless YouTube Channels Using AI Avatars: Success Stories from Arab Creators',
    content: "On YouTube, 'faceless' channels are booming, using tools like InVideo AI and HeyGen to generate scripts, stock footage, and lifelike avatars. I've compiled success stories from 5 Arab creators who built 100K+ subscriber channels without ever showing their face. The future of content is here!",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-067',
      username: 'YouTube Analyst',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20analytical%20expression%20wearing%20professional%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre11&orientation=squarish',
      reputation: 456
    },
    upvotes: 189,
    downvotes: 15,
    commentCount: 67,
    views: 4567,
    tags: ['faceless-channels', 'ai-avatars', 'youtube', 'heygen', 'invideo'],
    isPinned: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'disc-010',
    slug: 'ahmed-hassan-directorial-vision-desert-winds-interview',
    title: "Ahmed Hassan's Directorial Vision: Behind the Scenes of Desert Winds",
    content: "Just watched an interview with Ahmed Hassan about his creative process for Desert Winds. His attention to detail and artistic vision is truly compelling.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-010',
      username: 'Omar Khalil',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20thoughtful%20expression%20wearing%20casual%20modern%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=disc10&orientation=squarish',
      reputation: 389
    },
    upvotes: 62,
    downvotes: 4,
    commentCount: 19,
    views: 934,
    tags: ['ahmed-hassan', 'directing', 'desert-winds'],
    isPinned: false,
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-012',
    slug: 'elevenlabs-voice-dubbing-arab-creators-guide',
    title: 'How Arab Creators Are Using ElevenLabs for Multi-Language Dubbing',
    content: "ElevenLabs has become essential for creators wanting to reach global audiences. I spoke with 3 Arab drama creators who use it for high-quality voiceovers and dubbing. One creator increased their international viewership by 400% just by adding English and Spanish dubs!",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-068',
      username: 'Voice Tech Expert',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20tech-savvy%20expression%20wearing%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre12&orientation=squarish',
      reputation: 378
    },
    upvotes: 145,
    downvotes: 8,
    commentCount: 45,
    views: 2890,
    tags: ['elevenlabs', 'dubbing', 'voice-ai', 'multilingual', 'global-reach'],
    isPinned: false,
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-003',
    slug: 'rising-star-maya-ibrahim-interview',
    title: 'Rising Star: Maya Ibrahim on Her Breakthrough Role',
    content: "Maya Ibrahim went from unknown to household name in just one season. Her interview about preparing for the role of Salma in 'Golden Sands' is truly inspiring.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-028',
      username: 'Drama Weekly',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20media%20journalist%20with%20professional%20expression%20wearing%20business%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre3&orientation=squarish',
      reputation: 567
    },
    upvotes: 78,
    downvotes: 2,
    commentCount: 23,
    views: 1456,
    tags: ['maya-ibrahim', 'rising-star', 'golden-sands', 'interview'],
    isPinned: false,
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-004',
    slug: 'screenwriter-nadia-hassan-craft-storytelling',
    title: "The Craft of Storytelling: Screenwriter Nadia Hassan's Process",
    content: "Nadia Hassan has written some of the most beloved dramas of the past decade. Her approach to character development and dialogue is a masterclass in screenwriting.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-029',
      username: 'Script Analysis',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20intellectual%20expression%20wearing%20glasses%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre4&orientation=squarish',
      reputation: 423
    },
    upvotes: 56,
    downvotes: 1,
    commentCount: 18,
    views: 987,
    tags: ['nadia-hassan', 'screenwriting', 'storytelling', 'craft'],
    isPinned: false,
    createdAt: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-005',
    slug: 'composer-omar-fayed-music-emotions',
    title: 'How Composer Omar Fayed Creates Emotional Soundscapes',
    content: "The music in Arab dramas often makes or breaks emotional scenes. Omar Fayed discusses how he composes music that perfectly captures each moment's feeling.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-030',
      username: 'Music Lover',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20artistic%20expression%20wearing%20creative%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre5&orientation=squarish',
      reputation: 345
    },
    upvotes: 89,
    downvotes: 2,
    commentCount: 27,
    views: 1234,
    tags: ['omar-fayed', 'composer', 'soundtrack', 'music'],
    isPinned: false,
    createdAt: new Date(Date.now() - 14 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 13 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-006',
    slug: 'veteran-actor-khalid-mansour-career-retrospective',
    title: 'Veteran Actor Khalid Mansour: A Career Retrospective',
    content: "With over 30 years in the industry, Khalid Mansour has seen Arab drama evolve tremendously. His insights on the industry's growth are fascinating.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-031',
      username: 'Classic Drama Fan',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20respectful%20expression%20wearing%20elegant%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre6&orientation=squarish',
      reputation: 289
    },
    upvotes: 67,
    downvotes: 1,
    commentCount: 15,
    views: 876,
    tags: ['khalid-mansour', 'veteran', 'retrospective', 'career'],
    isPinned: false,
    createdAt: new Date(Date.now() - 18 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 17 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'cre-007',
    slug: 'producer-sarah-ahmed-business-creativity',
    title: 'Producer Sarah Ahmed on Balancing Business and Creativity',
    content: "Being a producer means making tough decisions. Sarah Ahmed shares how she maintains artistic integrity while ensuring commercial success.",
    category: 'creators',
    categoryName: 'Creator Spotlight',
    author: {
      id: 'user-032',
      username: 'Industry Insider',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20business%20expression%20wearing%20suit%20studio%20lighting%20clean%20background&width=80&height=80&seq=cre7&orientation=squarish',
      reputation: 456
    },
    upvotes: 45,
    downvotes: 3,
    commentCount: 21,
    views: 765,
    tags: ['sarah-ahmed', 'producer', 'business', 'creativity'],
    isPinned: false,
    createdAt: new Date(Date.now() - 22 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 21 * 60 * 60 * 1000).toISOString()
  },

  // ============ RECOMMENDATIONS (10 posts) ============
  {
    id: 'disc-006',
    slug: 'hidden-gems-underrated-arab-dramas-must-watch',
    title: 'Hidden Gems: 5 Underrated Arab Dramas You Must Watch',
    content: "I've discovered some incredible dramas that don't get enough attention. These hidden gems deserve more recognition from the community.",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-006',
      username: 'Layla Farouk',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20enthusiastic%20expression%20wearing%20colorful%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=disc6&orientation=squarish',
      reputation: 423
    },
    upvotes: 67,
    downvotes: 2,
    commentCount: 28,
    views: 1567,
    tags: ['hidden-gems', 'underrated', 'must-watch'],
    recommendedDramas: ["The Merchant's Tale", 'Coastal Dreams', 'Mountain Echoes'],
    isPinned: true,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-011',
    slug: 'best-ai-generated-dramas-2025-must-watch-list',
    title: 'Best AI-Generated Dramas of 2025: My Must-Watch List',
    content: "AI dramas have come a long way! Here are my top picks: Warlord for sci-fi fans, Beyond the Loop for anthology lovers, and Castle Walls for historical drama enthusiasts. The production quality has improved dramatically - some scenes are indistinguishable from traditional productions!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-069',
      username: 'AI Drama Curator',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20woman%20with%20curating%20expression%20wearing%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rec11&orientation=squarish',
      reputation: 456
    },
    upvotes: 234,
    downvotes: 34,
    commentCount: 89,
    views: 5678,
    tags: ['ai-dramas', '2025', 'must-watch', 'warlord', 'beyond-the-loop'],
    recommendedDramas: ['Warlord', 'Beyond the Loop', 'Castle Walls'],
    isPinned: true,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-012',
    slug: 'micro-dramas-under-2-minutes-perfect-commute',
    title: 'Micro-Dramas Under 2 Minutes: Perfect for Your Commute',
    content: "Don't have time for long episodes? These micro-dramas pack complete story arcs into 90-second episodes. His Highness Bichon Rules The Empire is hilarious, and The Cat Daddy Chronicles is heartwarming. Perfect for quick entertainment breaks!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-070',
      username: 'Busy Professional',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20busy%20expression%20wearing%20business%20casual%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rec12&orientation=squarish',
      reputation: 312
    },
    upvotes: 178,
    downvotes: 12,
    commentCount: 56,
    views: 3456,
    tags: ['micro-dramas', 'short-content', 'commute', 'quick-watch'],
    recommendedDramas: ['His Highness Bichon Rules The Empire', 'The Cat Daddy Chronicles', 'Quick Bites'],
    isPinned: false,
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-002',
    slug: 'best-romance-dramas-2024-list',
    title: 'Best Romance Dramas of 2024 - My Top 10 List',
    content: "If you're a romance fan like me, these dramas will make your heart flutter. From slow burns to instant chemistry, this list has it all!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-035',
      username: 'Romance Queen',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20dreamy%20expression%20wearing%20romantic%20attire%20soft%20lighting%20clean%20background&width=80&height=80&seq=rec2&orientation=squarish',
      reputation: 534
    },
    upvotes: 123,
    downvotes: 5,
    commentCount: 67,
    views: 3456,
    tags: ['romance', '2024', 'top-10', 'love-stories'],
    recommendedDramas: ['Hearts of Dubai', 'Moonlit Promises', 'Garden of Love'],
    isPinned: false,
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-003',
    slug: 'thriller-mystery-dramas-recommendations',
    title: 'Edge of Your Seat: Best Thriller & Mystery Dramas',
    content: "Love plot twists and suspense? These dramas will keep you guessing until the very end. Perfect for binge-watching sessions!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-036',
      username: 'Mystery Maven',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20mysterious%20expression%20wearing%20dark%20attire%20dramatic%20lighting%20clean%20background&width=80&height=80&seq=rec3&orientation=squarish',
      reputation: 389
    },
    upvotes: 89,
    downvotes: 3,
    commentCount: 45,
    views: 2345,
    tags: ['thriller', 'mystery', 'suspense', 'plot-twists'],
    recommendedDramas: ['Midnight Secrets', 'The Witness', 'Dark Waters'],
    isPinned: false,
    createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-004',
    slug: 'family-friendly-dramas-watch-together',
    title: 'Family-Friendly Dramas to Watch Together',
    content: "Looking for dramas the whole family can enjoy? These heartwarming stories are perfect for family viewing nights without awkward scenes.",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-037',
      username: 'Family Viewer',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20woman%20with%20warm%20motherly%20expression%20wearing%20comfortable%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=rec4&orientation=squarish',
      reputation: 267
    },
    upvotes: 78,
    downvotes: 1,
    commentCount: 34,
    views: 1890,
    tags: ['family-friendly', 'wholesome', 'all-ages', 'heartwarming'],
    recommendedDramas: ['The Bakery', 'Grandma Knows Best', 'Summer Memories'],
    isPinned: false,
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 11 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-005',
    slug: 'historical-period-dramas-recommendations',
    title: 'Step Back in Time: Best Historical Period Dramas',
    content: "These dramas transport you to different eras with stunning costumes, sets, and storytelling. History buffs will love these!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-038',
      username: 'History Buff',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20man%20with%20scholarly%20expression%20wearing%20traditional%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rec5&orientation=squarish',
      reputation: 456
    },
    upvotes: 67,
    downvotes: 2,
    commentCount: 29,
    views: 1567,
    tags: ['historical', 'period-drama', 'costumes', 'culture'],
    recommendedDramas: ['The Last Garden', 'Silk Road Tales', 'Palace Intrigue'],
    isPinned: false,
    createdAt: new Date(Date.now() - 16 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 15 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-006',
    slug: 'short-dramas-under-10-episodes',
    title: 'Quick Watches: Best Dramas Under 10 Episodes',
    content: "Don't have time for long series? These compact dramas pack powerful stories into fewer episodes. Perfect for busy schedules!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-039',
      username: 'Busy Bee',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20energetic%20expression%20wearing%20business%20casual%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rec6&orientation=squarish',
      reputation: 234
    },
    upvotes: 56,
    downvotes: 1,
    commentCount: 23,
    views: 1234,
    tags: ['short-series', 'quick-watch', 'compact', 'efficient'],
    recommendedDramas: ['One Week', 'The Decision', 'Crossroads'],
    isPinned: false,
    createdAt: new Date(Date.now() - 20 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 19 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-007',
    slug: 'comedy-dramas-laugh-out-loud',
    title: 'Laugh Out Loud: Funniest Arab Comedy Dramas',
    content: "Need a good laugh? These comedy dramas will have you in stitches. Perfect for lifting your mood after a long day!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-040',
      username: 'Comedy Fan',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20laughing%20expression%20wearing%20casual%20fun%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=rec7&orientation=squarish',
      reputation: 312
    },
    upvotes: 89,
    downvotes: 4,
    commentCount: 38,
    views: 1789,
    tags: ['comedy', 'funny', 'humor', 'lighthearted'],
    recommendedDramas: ['Chaos at Home', 'The Matchmaker', 'Office Antics'],
    isPinned: false,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 23 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'rec-008',
    slug: 'dramas-strong-female-leads',
    title: 'Girl Power: Dramas with Strong Female Leads',
    content: "These dramas feature powerful, complex female protagonists who drive the story. Inspiring characters you'll root for!",
    category: 'recommendations',
    categoryName: 'Recommendations',
    author: {
      id: 'user-041',
      username: 'Empowered Viewer',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20confident%20powerful%20expression%20wearing%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=rec8&orientation=squarish',
      reputation: 478
    },
    upvotes: 134,
    downvotes: 8,
    commentCount: 56,
    views: 2890,
    tags: ['female-lead', 'strong-women', 'empowering', 'inspiring'],
    recommendedDramas: ['Noor', 'The CEO', 'Breaking Barriers'],
    isPinned: false,
    createdAt: new Date(Date.now() - 28 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 27 * 60 * 60 * 1000).toISOString()
  },

  // ============ INDUSTRY NEWS (12 posts) ============
  {
    id: 'disc-007',
    slug: 'new-uae-production-studio-dubai-media-city',
    title: 'New UAE Production Studio Opens in Dubai Media City',
    content: 'A state-of-the-art production facility has opened in Dubai, promising to revolutionize Arab drama production with cutting-edge technology.',
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-007',
      username: 'Media Reporter',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20journalist%20with%20professional%20expression%20wearing%20business%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=disc7&orientation=squarish',
      reputation: 567
    },
    upvotes: 42,
    downvotes: 1,
    commentCount: 8,
    views: 654,
    tags: ['uae', 'production', 'dubai', 'studio'],
    isBreaking: false,
    source: 'Industry Insider',
    isPinned: false,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-011',
    slug: 'disney-openai-billion-dollar-deal-sora-characters',
    title: 'BREAKING: Disney Signs $1 Billion Deal with OpenAI to License Characters for Sora',
    content: "In a groundbreaking move, Disney has signed a $1 billion deal with OpenAI to license its characters for use with the Sora AI video platform. This means we could soon see AI-generated content featuring beloved Disney characters. The implications for the entertainment industry are massive!",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-071',
      username: 'Entertainment Breaking',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20journalist%20with%20breaking%20news%20expression%20wearing%20formal%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news11&orientation=squarish',
      reputation: 678
    },
    upvotes: 456,
    downvotes: 23,
    commentCount: 234,
    views: 12345,
    tags: ['disney', 'openai', 'sora', 'billion-dollar-deal', 'breaking'],
    isBreaking: true,
    source: 'Variety',
    isPinned: true,
    createdAt: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 15 * 60 * 1000).toISOString()
  },
  {
    id: 'news-012',
    slug: 'runway-gen-4-5-tops-video-arena-leaderboard',
    title: 'Runway Gen-4.5 Takes #1 Spot on Video Arena Leaderboard, Surpassing Google and OpenAI',
    content: "Runway's Gen-4.5, released in December 2025, has claimed the top position on the independent Video Arena leaderboard, beating both Google and OpenAI in motion quality and prompt adherence. The new 'Infinite Character Consistency' feature is a game-changer for drama creators!",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-072',
      username: 'AI Tech Reporter',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20man%20with%20tech-savvy%20expression%20wearing%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news12&orientation=squarish',
      reputation: 534
    },
    upvotes: 289,
    downvotes: 12,
    commentCount: 89,
    views: 6789,
    tags: ['runway', 'gen-4-5', 'ai-video', 'leaderboard', 'openai'],
    isBreaking: true,
    source: 'CNBC',
    isPinned: false,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 45 * 60 * 1000).toISOString()
  },
  {
    id: 'news-013',
    slug: 'openai-sora-2-integrated-audio-dialogue-sfx',
    title: 'OpenAI Sora 2 Now Generates Synchronized Dialogue and Sound Effects',
    content: "A major September 2025 update added native synchronized dialogue and sound effects generation directly into Sora 2's video output. The new 'Cameo' feature also allows users to seamlessly insert real people into AI-generated scenes. This is huge for drama production!",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-073',
      username: 'Sora Updates',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20excited%20expression%20wearing%20professional%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news13&orientation=squarish',
      reputation: 456
    },
    upvotes: 345,
    downvotes: 18,
    commentCount: 67,
    views: 8901,
    tags: ['sora-2', 'openai', 'audio', 'dialogue', 'cameo'],
    isBreaking: false,
    source: 'OpenAI Blog',
    isPinned: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-014',
    slug: 'amazon-350-ai-shots-house-of-david-season-2',
    title: 'Amazon Uses 350 AI-Generated Shots in House of David Season 2',
    content: "Amazon has confirmed using 350 AI-generated shots in the second season of House of David to enhance efficiency. Meanwhile, Netflix used generative AI for a complex building collapse scene in The Eternaut. Major studios are embracing AI at unprecedented scale!",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-074',
      username: 'Streaming News',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20informed%20expression%20wearing%20business%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news14&orientation=squarish',
      reputation: 423
    },
    upvotes: 178,
    downvotes: 45,
    commentCount: 89,
    views: 4567,
    tags: ['amazon', 'netflix', 'ai-vfx', 'house-of-david', 'the-eternaut'],
    isBreaking: false,
    source: 'The Hollywood Reporter',
    isPinned: false,
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-015',
    slug: 'micro-drama-industry-90-billion-yuan-2025',
    title: 'Micro-Drama Industry Projected to Reach $12.5 Billion by End of 2025',
    content: "The micro-drama industry is booming! Projected to reach nearly 90 billion yuan (~$12.5 billion) by end of 2025, with AI-driven content often boasting net profit margins exceeding 50%. Arab content creators are taking notice of this lucrative market.",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-075',
      username: 'Market Analyst',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20analytical%20expression%20wearing%20business%20suit%20studio%20lighting%20clean%20background&width=80&height=80&seq=news15&orientation=squarish',
      reputation: 567
    },
    upvotes: 234,
    downvotes: 8,
    commentCount: 67,
    views: 5678,
    tags: ['micro-drama', 'market-size', 'billion-dollar', 'industry-growth'],
    isBreaking: false,
    source: 'Bloomberg',
    isPinned: false,
    createdAt: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'disc-011',
    slug: 'streaming-platform-investment-arab-content-announcement',
    title: 'Streaming Platform Announces Major Investment in Arab Content',
    content: 'A leading streaming service has committed $50 million to producing original Arab short dramas, signaling growing international interest in the region.',
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-011',
      username: 'Entertainment News',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20media%20correspondent%20with%20confident%20expression%20wearing%20modern%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=disc11&orientation=squarish',
      reputation: 489
    },
    upvotes: 67,
    downvotes: 2,
    commentCount: 14,
    views: 1234,
    tags: ['streaming', 'investment', 'original-content'],
    isBreaking: false,
    source: 'Variety Middle East',
    isPinned: false,
    createdAt: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-003',
    slug: 'arab-drama-awards-2024-nominations-announced',
    title: 'Arab Drama Awards 2024: Full Nominations List Announced',
    content: "The nominations for this year's Arab Drama Awards are out! Noor leads with 8 nominations, followed by Desert Winds with 6. See the complete list inside.",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-044',
      username: 'Awards Watch',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20journalist%20with%20excited%20expression%20wearing%20formal%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news3&orientation=squarish',
      reputation: 623
    },
    upvotes: 156,
    downvotes: 3,
    commentCount: 89,
    views: 4567,
    tags: ['awards', '2024', 'nominations', 'noor', 'desert-winds'],
    isBreaking: false,
    source: 'Arab Drama Awards Official',
    isPinned: false,
    createdAt: new Date(Date.now() - 11 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-004',
    slug: 'layla-al-rashid-signs-exclusive-deal',
    title: 'Breaking: Layla Al-Rashid Signs Exclusive 3-Year Deal',
    content: "Fan-favorite actress Layla Al-Rashid has signed an exclusive deal with a major production company. Details on her upcoming projects inside.",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-045',
      username: 'Celebrity News',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20journalist%20with%20breaking%20news%20expression%20wearing%20professional%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news4&orientation=squarish',
      reputation: 534
    },
    upvotes: 234,
    downvotes: 5,
    commentCount: 67,
    views: 5678,
    tags: ['layla-al-rashid', 'exclusive-deal', 'breaking', 'contract'],
    isBreaking: false,
    source: 'Entertainment Weekly Arabia',
    isPinned: false,
    createdAt: new Date(Date.now() - 13 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-005',
    slug: 'desert-winds-season-2-confirmed',
    title: 'Desert Winds Season 2 Officially Confirmed for 2025',
    content: "Great news for Desert Winds fans! The production company has officially confirmed Season 2, with filming set to begin in early 2025.",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-046',
      username: 'Drama Updates',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20happy%20expression%20wearing%20casual%20professional%20attire%20natural%20lighting%20clean%20background&width=80&height=80&seq=news5&orientation=squarish',
      reputation: 456
    },
    upvotes: 345,
    downvotes: 2,
    commentCount: 123,
    views: 7890,
    tags: ['desert-winds', 'season-2', 'confirmed', '2025'],
    isBreaking: false,
    source: 'Official Announcement',
    isPinned: false,
    createdAt: new Date(Date.now() - 15 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 14 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-007',
    slug: 'international-remake-rights-noor-sold',
    title: 'International Remake Rights for Noor Sold to Hollywood Studio',
    content: "In a historic deal, a major Hollywood studio has acquired the rights to remake Noor for international audiences. This marks a milestone for Arab content.",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-048',
      username: 'Global Entertainment',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20woman%20with%20proud%20expression%20wearing%20elegant%20business%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news7&orientation=squarish',
      reputation: 567
    },
    upvotes: 278,
    downvotes: 12,
    commentCount: 156,
    views: 6789,
    tags: ['noor', 'hollywood', 'remake', 'international', 'historic'],
    isBreaking: false,
    source: 'Deadline Middle East',
    isPinned: false,
    createdAt: new Date(Date.now() - 18 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 17 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'news-016',
    slug: 'darren-aronofsky-ai-film-backlash-1776',
    title: 'Darren Aronofsky\'s AI Film "On This Day... 1776" Faces Viewer Backlash',
    content: "High-profile AI projects aren't immune to criticism. Darren Aronofsky's 'On This Day... 1776' has faced significant backlash from viewers citing technical gaps and lack of 'human touch'. This raises important questions about the future of AI in prestige filmmaking.",
    category: 'news',
    categoryName: 'Industry News',
    author: {
      id: 'user-076',
      username: 'Film Critic',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20critical%20expression%20wearing%20intellectual%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=news16&orientation=squarish',
      reputation: 489
    },
    upvotes: 145,
    downvotes: 34,
    commentCount: 112,
    views: 4567,
    tags: ['aronofsky', 'ai-backlash', '1776', 'criticism', 'human-touch'],
    isBreaking: false,
    source: 'IndieWire',
    isPinned: false,
    createdAt: new Date(Date.now() - 20 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 19 * 60 * 60 * 1000).toISOString()
  },

  // ============ BEHIND THE SCENES (10 posts) ============
  {
    id: 'disc-008',
    slug: 'filming-dubai-desert-behind-scenes-desert-winds',
    title: 'Filming in the Dubai Desert: Behind the Scenes of Desert Winds',
    content: "The production team faced incredible challenges filming in the harsh desert conditions. Here's how they captured those stunning scenes that made the show so visually impressive.",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-008',
      username: 'Production Insider',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20film%20production%20crew%20member%20with%20adventurous%20expression%20wearing%20desert%20filming%20gear%20natural%20lighting%20clean%20background&width=80&height=80&seq=disc8&orientation=squarish',
      reputation: 378
    },
    upvotes: 58,
    downvotes: 2,
    commentCount: 16,
    views: 1123,
    tags: ['desert-winds', 'dubai', 'filming', 'challenges'],
    drama: 'Desert Winds',
    isPinned: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-010',
    slug: 'runway-infinite-character-consistency-workflow',
    title: 'How Creators Use Runway\'s Infinite Character Consistency for Drama Production',
    content: "Runway's Gen-4 'Infinite Character Consistency' feature allows maintaining a character's look across endless environments using just one reference image. I interviewed a creator who produced an entire 10-episode series using this technique. The workflow is revolutionary!",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-077',
      username: 'AI Workflow Expert',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20man%20with%20technical%20expression%20wearing%20creative%20tech%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=bts10&orientation=squarish',
      reputation: 456
    },
    upvotes: 234,
    downvotes: 12,
    commentCount: 78,
    views: 4567,
    tags: ['runway', 'character-consistency', 'ai-workflow', 'production'],
    drama: 'AI Production',
    isPinned: true,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-011',
    slug: 'opusclip-revid-ai-repurposing-long-form-content',
    title: 'From YouTube to TikTok: Using OpusClip and Revid AI for Content Repurposing',
    content: "Tools like OpusClip and Revid AI automatically turn long-form YouTube videos into viral TikTok clips. I tested both with a 30-minute drama review and got 15 perfectly edited short clips in minutes. Here's my complete workflow breakdown!",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-078',
      username: 'Content Repurposer',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20creative%20expression%20wearing%20content%20creator%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=bts11&orientation=squarish',
      reputation: 345
    },
    upvotes: 189,
    downvotes: 8,
    commentCount: 56,
    views: 3456,
    tags: ['opusclip', 'revid-ai', 'content-repurposing', 'youtube', 'tiktok'],
    drama: 'Content Creation',
    isPinned: false,
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-012',
    slug: 'descript-text-based-video-editing-drama-creators',
    title: 'Descript for Drama Creators: Edit Videos Like Editing a Document',
    content: "Descript's text-based video editing is a game-changer. You literally edit your video by editing the transcript - delete a word, and the video cuts automatically. Perfect for drama commentary and review content. Here's how I use it daily!",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-079',
      username: 'Editing Pro',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20focused%20expression%20wearing%20editor%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=bts12&orientation=squarish',
      reputation: 312
    },
    upvotes: 145,
    downvotes: 5,
    commentCount: 45,
    views: 2345,
    tags: ['descript', 'video-editing', 'text-based', 'workflow', 'tutorial'],
    drama: 'Content Creation',
    isPinned: false,
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'disc-012',
    slug: 'costume-design-art-creating-authentic-period-pieces',
    title: 'The Art of Costume Design: Creating Authentic Period Pieces',
    content: 'Costume designer Amira Khalil shares her process for creating historically accurate costumes for The Last Garden, blending tradition with cinematic appeal.',
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-012',
      username: 'Amira Khalil',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20costume%20designer%20with%20creative%20expression%20wearing%20artistic%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=disc12&orientation=squarish',
      reputation: 456
    },
    upvotes: 42,
    downvotes: 1,
    commentCount: 9,
    views: 678,
    tags: ['costume-design', 'last-garden', 'historical', 'authenticity'],
    drama: 'The Last Garden',
    isPinned: false,
    createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-003',
    slug: 'stunt-coordination-action-sequences-golden-sands',
    title: 'Stunt Coordination: Creating Safe Action Sequences in Golden Sands',
    content: "The action scenes in Golden Sands look dangerous but are meticulously planned. Stunt coordinator Rashid explains how they keep actors safe while delivering thrilling sequences.",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-052',
      username: 'Action Expert',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20athletic%20expression%20wearing%20action%20gear%20natural%20lighting%20clean%20background&width=80&height=80&seq=bts3&orientation=squarish',
      reputation: 389
    },
    upvotes: 67,
    downvotes: 1,
    commentCount: 23,
    views: 1456,
    tags: ['stunts', 'action', 'golden-sands', 'safety', 'coordination'],
    drama: 'Golden Sands',
    isPinned: false,
    createdAt: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-004',
    slug: 'set-design-building-fictional-worlds',
    title: 'Set Design Magic: Building the World of City of Dreams',
    content: "The sets of City of Dreams are so realistic that viewers often think they're real locations. Set designer Fatima reveals the secrets behind creating these immersive environments.",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-053',
      username: 'Set Design Pro',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20set%20designer%20with%20creative%20expression%20wearing%20artistic%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=bts4&orientation=squarish',
      reputation: 423
    },
    upvotes: 78,
    downvotes: 2,
    commentCount: 19,
    views: 1234,
    tags: ['set-design', 'city-of-dreams', 'production-design', 'creativity'],
    drama: 'City of Dreams',
    isPinned: false,
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 11 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-005',
    slug: 'makeup-transformation-aging-characters',
    title: 'Makeup Transformation: Aging Characters 30 Years in Noor',
    content: "The aging makeup in Noor's flashback scenes is incredibly realistic. Makeup artist Leila shares the 4-hour process of transforming young actors into elderly characters.",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-054',
      username: 'Makeup Artist',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20makeup%20artist%20with%20artistic%20expression%20wearing%20professional%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=bts5&orientation=squarish',
      reputation: 345
    },
    upvotes: 89,
    downvotes: 2,
    commentCount: 27,
    views: 1789,
    tags: ['makeup', 'transformation', 'noor', 'aging', 'prosthetics'],
    drama: 'Noor',
    isPinned: false,
    createdAt: new Date(Date.now() - 16 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 15 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'bts-006',
    slug: 'vfx-breakdown-creating-impossible-scenes',
    title: 'VFX Breakdown: Creating Impossible Scenes in Desert Winds',
    content: "Some scenes in Desert Winds look impossible to film - because they are! VFX supervisor Ahmed breaks down how CGI enhanced the most spectacular moments.",
    category: 'behind-scenes',
    categoryName: 'Behind the Scenes',
    author: {
      id: 'user-057',
      username: 'VFX Insider',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20VFX%20artist%20with%20tech-savvy%20expression%20wearing%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=bts6&orientation=squarish',
      reputation: 456
    },
    upvotes: 98,
    downvotes: 3,
    commentCount: 34,
    views: 2100,
    tags: ['vfx', 'cgi', 'desert-winds', 'visual-effects', 'breakdown'],
    drama: 'Desert Winds',
    isPinned: false,
    createdAt: new Date(Date.now() - 28 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 27 * 60 * 60 * 1000).toISOString()
  },

  // ============ AI DRAMAS (12 posts) ============
  {
    id: 'ai-001',
    slug: 'sora-vs-runway-gen4-which-is-better-for-drama-creation',
    title: 'Sora vs Runway Gen-4.5: Which is Better for Drama Creation in 2025?',
    content: "I've been testing both platforms extensively for my AI drama projects. Sora excels at dialogue and audio integration, while Runway's character consistency is unmatched. Here's my detailed comparison with sample outputs from both!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-001',
      username: 'AI Creator Pro',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20tech-savvy%20Middle%20Eastern%20man%20with%20innovative%20expression%20wearing%20modern%20creative%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai001&orientation=squarish',
      reputation: 567
    },
    upvotes: 345,
    downvotes: 23,
    commentCount: 156,
    views: 8901,
    tags: ['sora', 'runway', 'comparison', 'ai-tools', 'drama-creation'],
    isPinned: true,
    createdAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 30 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-002',
    slug: 'my-first-ai-generated-short-drama-lessons-learned',
    title: 'My First AI-Generated Short Drama: 10 Lessons Learned the Hard Way',
    content: "After 3 months of work, I finally released my first fully AI-generated 10-episode drama. From character consistency nightmares to audio sync issues, here's everything I wish I knew before starting. Hope this helps fellow creators!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-002',
      username: 'First Time Creator',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20determined%20expression%20wearing%20casual%20creative%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai002&orientation=squarish',
      reputation: 234
    },
    upvotes: 456,
    downvotes: 12,
    commentCount: 189,
    views: 12345,
    tags: ['beginner', 'lessons-learned', 'tutorial', 'first-project'],
    isPinned: true,
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-003',
    slug: 'kling-ai-review-best-for-arab-drama-aesthetics',
    title: 'Kling AI Review: Is It the Best Choice for Arab Drama Aesthetics?',
    content: "Kling AI has been gaining popularity for its ability to generate culturally authentic visuals. I tested it specifically for Arab drama settings - traditional architecture, desert landscapes, and period costumes. The results are impressive!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-003',
      username: 'Cultural AI Artist',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20artistic%20expression%20wearing%20traditional%20modern%20fusion%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai003&orientation=squarish',
      reputation: 423
    },
    upvotes: 234,
    downvotes: 18,
    commentCount: 78,
    views: 5678,
    tags: ['kling-ai', 'arab-aesthetics', 'cultural', 'review', 'visuals'],
    isPinned: false,
    createdAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-004',
    slug: 'character-consistency-masterclass-maintaining-looks-across-episodes',
    title: 'Character Consistency Masterclass: Maintaining Looks Across 50+ Scenes',
    content: "The biggest challenge in AI drama creation is keeping characters looking the same. I've developed a workflow using Runway's Infinite Character Consistency + LoRA training that achieves 95% consistency. Full tutorial inside!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-004',
      username: 'Consistency Expert',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20technical%20expression%20wearing%20professional%20creative%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai004&orientation=squarish',
      reputation: 678
    },
    upvotes: 567,
    downvotes: 34,
    commentCount: 156,
    views: 15678,
    tags: ['character-consistency', 'tutorial', 'workflow', 'lora', 'masterclass'],
    isPinned: false,
    createdAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-005',
    slug: 'ai-voice-cloning-for-drama-elevenlabs-vs-alternatives',
    title: 'AI Voice Cloning for Drama: ElevenLabs vs Alternatives Compared',
    content: "Voice is crucial for drama. I compared ElevenLabs, PlayHT, and Resemble AI for Arabic dialogue generation. ElevenLabs wins for quality, but there are cheaper alternatives that work well for certain use cases.",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-005',
      username: 'Voice Tech Reviewer',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20audio%20engineer%20expression%20wearing%20headphones%20around%20neck%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai005&orientation=squarish',
      reputation: 389
    },
    upvotes: 189,
    downvotes: 15,
    commentCount: 67,
    views: 4567,
    tags: ['voice-cloning', 'elevenlabs', 'audio', 'comparison', 'arabic'],
    isPinned: false,
    createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-006',
    slug: 'the-ethics-of-ai-dramas-where-do-we-draw-the-line',
    title: 'The Ethics of AI Dramas: Where Do We Draw the Line?',
    content: "As AI dramas become more realistic, we need to discuss ethics. Should AI actors be disclosed? What about using real people's likenesses? Let's have an honest conversation about responsible AI content creation.",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-006',
      username: 'Ethics Advocate',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20thoughtful%20philosophical%20expression%20wearing%20professional%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai006&orientation=squarish',
      reputation: 512
    },
    upvotes: 345,
    downvotes: 45,
    commentCount: 234,
    views: 7890,
    tags: ['ethics', 'ai-disclosure', 'responsibility', 'debate', 'future'],
    isPinned: false,
    createdAt: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-007',
    slug: 'budget-breakdown-creating-ai-drama-under-500-dollars',
    title: 'Budget Breakdown: Creating a Full AI Drama Series Under $500',
    content: "You don't need thousands to create quality AI content. Here's my complete budget breakdown for a 12-episode series: Runway ($96), ElevenLabs ($22), music ($50), and free tools for the rest. Total: $478!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-007',
      username: 'Budget Creator',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Middle%20Eastern%20man%20with%20resourceful%20expression%20wearing%20casual%20startup%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai007&orientation=squarish',
      reputation: 345
    },
    upvotes: 678,
    downvotes: 12,
    commentCount: 156,
    views: 18901,
    tags: ['budget', 'affordable', 'cost-breakdown', 'indie', 'tutorial'],
    isPinned: false,
    createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-008',
    slug: 'showcase-desert-echoes-my-ai-generated-romance-drama',
    title: 'Showcase: "Desert Echoes" - My AI-Generated Romance Drama (Full Series)',
    content: "Proud to share my completed AI drama 'Desert Echoes' - a 15-episode romance set in 1950s Dubai. Created entirely with Sora, Runway, and ElevenLabs. Watch the full series and let me know your thoughts!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-008',
      username: 'Desert Echoes Creator',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20proud%20creative%20expression%20wearing%20elegant%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai008&orientation=squarish',
      reputation: 456
    },
    upvotes: 567,
    downvotes: 34,
    commentCount: 189,
    views: 23456,
    tags: ['showcase', 'desert-echoes', 'romance', 'completed-series', 'watch'],
    isPinned: false,
    createdAt: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 9 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-009',
    slug: 'prompt-engineering-for-drama-scenes-advanced-techniques',
    title: 'Prompt Engineering for Drama Scenes: Advanced Techniques That Work',
    content: "Your prompts make or break your AI drama. After generating 1000+ scenes, I've compiled my best prompt templates for dialogue scenes, action sequences, emotional moments, and establishing shots. Free template pack included!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-009',
      username: 'Prompt Master',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20expert%20expression%20wearing%20tech%20creative%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai009&orientation=squarish',
      reputation: 623
    },
    upvotes: 456,
    downvotes: 8,
    commentCount: 134,
    views: 12345,
    tags: ['prompt-engineering', 'templates', 'advanced', 'techniques', 'free'],
    isPinned: false,
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 11 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-010',
    slug: 'ai-drama-monetization-how-im-earning-from-my-content',
    title: 'AI Drama Monetization: How I\'m Earning $3K/Month from My Content',
    content: "Many ask if AI dramas can be monetized. Yes! I'm earning through YouTube ads, Patreon, and licensing. Here's my complete monetization strategy and revenue breakdown after 6 months of consistent posting.",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-010',
      username: 'Monetization Pro',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20business%20savvy%20expression%20wearing%20professional%20modern%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai010&orientation=squarish',
      reputation: 534
    },
    upvotes: 789,
    downvotes: 45,
    commentCount: 267,
    views: 34567,
    tags: ['monetization', 'income', 'youtube', 'patreon', 'business'],
    isPinned: false,
    createdAt: new Date(Date.now() - 14 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 13 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-011',
    slug: 'comfyui-workflows-for-drama-production-complete-guide',
    title: 'ComfyUI Workflows for Drama Production: Complete Setup Guide',
    content: "ComfyUI offers incredible control for AI video generation. I've created custom workflows specifically for drama production - character generation, scene composition, and batch processing. All workflows available for download!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-011',
      username: 'ComfyUI Expert',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Middle%20Eastern%20man%20with%20technical%20expert%20expression%20wearing%20developer%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai011&orientation=squarish',
      reputation: 478
    },
    upvotes: 234,
    downvotes: 12,
    commentCount: 89,
    views: 8901,
    tags: ['comfyui', 'workflows', 'technical', 'guide', 'download'],
    isPinned: false,
    createdAt: new Date(Date.now() - 16 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 15 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'ai-012',
    slug: 'weekly-ai-drama-challenge-create-60-second-episode',
    title: 'Weekly AI Drama Challenge: Create a 60-Second Episode (Week 12)',
    content: "Welcome to Week 12 of our community challenge! This week's theme: 'Unexpected Reunion'. Create a 60-second AI drama episode and share it here. Best entries get featured on our community showcase!",
    category: 'ai-dramas',
    categoryName: 'AI Dramas',
    author: {
      id: 'user-ai-012',
      username: 'Challenge Host',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Arab%20woman%20with%20enthusiastic%20host%20expression%20wearing%20vibrant%20creative%20attire%20studio%20lighting%20clean%20background&width=80&height=80&seq=ai012&orientation=squarish',
      reputation: 567
    },
    upvotes: 234,
    downvotes: 5,
    commentCount: 156,
    views: 6789,
    tags: ['challenge', 'weekly', 'community', 'contest', 'showcase'],
    isPinned: false,
    createdAt: new Date(Date.now() - 18 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 17 * 60 * 60 * 1000).toISOString()
  }
];

export const discussionCategories = [
  { id: 'general', name: 'General Discussion', slug: 'general', icon: 'ri-chat-3-line', color: 'text-blue-500', bgColor: 'bg-blue-500' },
  { id: 'ai-dramas', name: 'AI Dramas', slug: 'ai-dramas', icon: 'ri-robot-line', color: 'text-orange-500', bgColor: 'bg-orange-500' },
  { id: 'reviews', name: 'Drama Reviews', slug: 'reviews', icon: 'ri-star-line', color: 'text-yellow-500', bgColor: 'bg-yellow-500' },
  { id: 'creators', name: 'Creator Spotlight', slug: 'creators', icon: 'ri-user-star-line', color: 'text-purple-500', bgColor: 'bg-purple-500' },
  { id: 'recommendations', name: 'Recommendations', slug: 'recommendations', icon: 'ri-thumb-up-line', color: 'text-green-500', bgColor: 'bg-green-500' },
  { id: 'news', name: 'Industry News', slug: 'news', icon: 'ri-newspaper-line', color: 'text-red-500', bgColor: 'bg-red-500' },
  { id: 'behind-scenes', name: 'Behind the Scenes', slug: 'behind-scenes', icon: 'ri-camera-line', color: 'text-indigo-500', bgColor: 'bg-indigo-500' }
];

export const getDiscussionsByCategory = (category: string) => {
  return mockDiscussions.filter(d => d.category === category);
};

export const getDiscussionBySlug = (slug: string) => {
  return mockDiscussions.find(d => d.slug === slug || d.id === slug);
};

export const getDiscussionById = (id: string) => {
  return mockDiscussions.find(d => d.id === id);
};
